module.exports = __webpack_public_path__ + "media/images/icon__info--rb-gray@3x-b064ec0152b2f001312a3dec9c8ee86a.png";